module.exports = __webpack_public_path__ + "src/app/_content/imgs/icons/mini_brake_pads.jpg?a2979fa1485dea48a20d990c426c8e95";